import $ = require('jquery');
import {ListWidgetService} from "../service.listwidgets";
import {WebSocket} from "../websocket";
import { Utility} from '../utility';
import { Data } from '../data';
export default class waittimesController {
    static $inject = ["$scope", "$http", "ListWidgetService"];
    static AngularDependencies = ['$scope', '$http', 'ListWidgetService',waittimesController];

    private oldData: any;

    public WaitTimesList: any[] = [];
    public myOrder = ['location'];

    public waitTime: any;

    public flipOrder(sort: string) {
        if (sort == "location") {
            if (this.myOrder[0] == "location") {
                this.myOrder = ["-location"];
            }
            else if (this.myOrder[0] == "-location") {
                this.myOrder = ["location"];
            }
            else {
                this.myOrder = ["-location"];
            }
        }
        else if (sort == "lanesOpen") {
            if (this.myOrder[0] == "lanesOpen") {
                this.myOrder = ["-lanesOpen"];
            }
            else if (this.myOrder[0] == "-lanesOpen") {
                this.myOrder = ["lanesOpen"];
            }
            else {
                this.myOrder = ["lanesOpen"];
            }
        }
        else if (sort == "numCustomerWaiting") {
            if (this.myOrder[0] == "numCustomerWaiting") {
                this.myOrder = ["-numCustomerWaiting"];
            }
            else if (this.myOrder[0] == "-numCustomerWaiting") {
                this.myOrder = ["numCustomerWaiting"];
            }
            else {
                this.myOrder = ["numCustomerWaiting"];
            }
        }
    }
    
    public AddtoTMCWaitTimeList(waitTime) {
        this.waitTime = waitTime;
        this.WaitTimesList = [];

        for (let x = 0; x < this.waitTime.length; x++) {
            this.WaitTimesList.push({
                location: this.waitTime[x].queue_location,
                lanesOpen: this.waitTime[x].queue_open,
                numCustomerWaiting: this.waitTime[x].queue_tickets,
                lastCustomerWaited: this.waitTime[x].queue_actual_format,
                nextCustomerWaitTime: this.waitTime[x].queue_estimated_format,
                remainder: this.waitTime[x].queue_remainder,                 
            });
        }
        this.oldData = waitTime;
        this.ListWidgetService.updatecount("Wait Times", waitTime.length);
    }

    constructor($scope: ng.IScope, $http: angular.IHttpService, public ListWidgetService: ListWidgetService) {
        let vm = this;
        WebSocket.OnUpdate(function(data) {
            if(!Utility.deepEqual(vm.oldData,data.WaitTime)){
                vm.AddtoTMCWaitTimeList(data.WaitTime);
                $scope.$digest();
                $scope.$broadcast("waittimes_data_ready");
                $scope.$emit("list_changed");
            }
            
        });

        var acc = document.getElementsByClassName("topbar");
        var i;
        for (i = 0; i < acc.length; i++) {
            var test = <any>acc[i]
            test.onclick = function() {
                this.classList.toggle("active");
                this.nextElementSibling.children[0].classList.toggle("hide");
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/waittimes/controller.waittimes.ts